import CrudManager from "@/components/admin/CrudManager";

const FIELDS = [
  { key: "name", label: "Cluster name", required: true },
  { key: "career_family", label: "Career family", required: true },
  { key: "riasec_codes", label: "RIASEC codes (in order)", type: "codes", required: true, hint: "Comma separated, from R, I, A, S, E, C. e.g. I, R" },
  { key: "streams_subjects", label: "Streams / subjects" },
  { key: "description", label: "Description", type: "textarea", required: true },
  { key: "example_careers", label: "Example careers (one per line)", type: "list" },
  { key: "academic_pathways", label: "Academic pathway steps (one per line)", type: "list" },
  { key: "key_skills", label: "Key skills (one per line)", type: "list" },
  { key: "active", label: "Active", type: "bool" },
];

const COLUMNS = [
  { key: "name", label: "Cluster", render: (r) => <span className="font-semibold">{r.name}</span> },
  { key: "riasec_codes", label: "Codes", render: (r) => <span className="font-mono">{r.riasec_codes.join("")}</span> },
  { key: "career_family", label: "Family" },
  { key: "example_careers", label: "Example careers", render: (r) => <span className="text-[#635060]">{r.example_careers.slice(0, 3).join(", ")}</span> },
];

export default function CareerClusters() {
  return <CrudManager testId="clusters" endpoint="/admin/career-clusters" eyebrow="Career mapping" title="Career clusters" itemLabel="cluster"
    description="The controlled RIASEC-to-career-cluster map. The report uses this mapping directly; AI never changes it." fields={FIELDS} columns={COLUMNS} />;
}
